module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/footer_bg-7260de5ad0e79a1cd252d1afe2416132.jpg";